import React from "react";

import JobPage from "./JobPage";

const QA = () => (
    <JobPage
        title="QA Engineer"
        location="Malta"
        summary={[
            "Act as a QA Engineer across the platform.",
            "Use best practices when testing code and features.",
            "Write clear and concise documentation.",
            "Work with stakeholders to identify and document requirements.",
            "Participate in design reviews.",
            "Participate in agile rituals including standups, sprint reviews, sprint planning, and retrospectives.",
            "Support the company with advice on quality assurance — strategy, planning, tactics, and execution.",
        ]}
        tldrIntro="Don't read this unless you know"
        tldr={[
            "How to QA financial and crypto services and interfaces, especially for payments.",
            "How to work effectively on a distributed team.",
            "How to hit deadlines.",
        ]}
        requirements={[
            "5+ years' experience in a QA role.",
            "Familiarity with modern QA tools (bug/issue tracking, build tools, test automation, CI, etc.).",
            "Able to process payments on debit cards and SEPA; connect crypto wallets; test end-to-end flows of buying, trading, and selling tokens and fiat, including KYC/AML, risk rating, and reporting.",
            "BS or higher in Computer Science or related discipline (or equivalent experience).",
            "QA experience in banking, payment processing, forex, brokerage services, and/or crypto.",
            "Experience with Agile methodologies.",
            "Self-starter with a can-do attitude.",
            "Comfortable evaluating new technologies and weighing tradeoffs.",
        ]}
        experienceNeeded={[
            "Black-box / white-box testing.",
            "Deep expertise with bug tracking tools.",
            "Familiarity with APIs.",
        ]}
        desiredExperience={[
            "QA automation experience a plus.",
            "Crypto experience a plus.",
            "Digital wallet experience a plus.",
        ]}
    />
);

export default QA;
